import { useAuth } from "./AuthContext";
import { useLocation } from "react-router-dom";

export default function RequireRole({ role, children }) {
  const { loading, me, login } = useAuth();
  const location = useLocation();

  if (loading) return <div>Loading…</div>;

  if (!me.loggedIn) {
    login(location.pathname);
    return <div>Redirecting to login…</div>;
  }

  if (!me.user?.roles?.includes(role)) {
    return (
      <div className="container">
        <h2>Forbidden</h2>
        <p>You do not have permission to view this page.</p>
      </div>
    );
  }

  return children;
}
